module.exports = __webpack_public_path__ + "img/10.2ce9eaf9.png";